<template>
  <div
    v-if="loading"
    class="tw-flex tw-w-full"
    :style="`height: ${heightLoading ? heightLoading + 'px' : '100%'}`"
  >
    <span class="custom-global-skeleton tw-w-full tw-h-full"></span>
  </div>
  <div v-else class="container tw-overflow-y-hidden">
    <apexchart
      :key="chartId"
      ref="chartRef"
      width="100%"
      :height="height"
      :type="'line'"
      :options="chartOptions"
      :series="series"
      :class="`!tw-min-h-[0px] ${classChart}`"
    />
  </div>
</template>

<script lang="ts" setup>
import { ApexOptions } from "apexcharts";
import { nextTick, PropType, ref, watch } from "vue";

export interface IChartSeries {
  name: string;
  data: number[];
}

const props = defineProps({
  isPrint: {
    type: Boolean,
    required: false,
    default: false,
  },
  chartId: {
    type: Number,
    required: false,
    default: 1,
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  height: {
    type: [Number, String],
    required: true,
  },
  series: {
    type: Object as PropType<IChartSeries[]>,
    required: true,
  },
  chartOptions: {
    type: Object as PropType<ApexOptions>,
    default: () => ({
      stroke: { width: 3, curve: "smooth" },
      forecastDataPoints: { count: 5 },
      chart: { toolbar: { show: false } },
      xaxis: {
        type: "datetime",
        categories: [
          "1/11/2000",
          "2/11/2000",
          "3/11/2000",
          "4/11/2000",
          "5/11/2000",
          "6/11/2000",
          "7/11/2000",
          "8/11/2000",
          "9/11/2000",
          "10/11/2000",
          "11/11/2000",
          "12/11/2000",
          "1/11/2001",
          "2/11/2001",
          "3/11/2001",
          "4/11/2001",
          "5/11/2001",
          "6/11/2001",
        ],
        tickAmount: 10,
        labels: {
          formatter: function (value, timestamp, opts) {
            const monthNames = [
              "J",
              "F",
              "M",
              "A",
              "M",
              "J",
              "J",
              "A",
              "S",
              "O",
              "N",
              "D",
            ];

            return monthNames[new Date(timestamp).getMonth()];
          },
        },
      },
      yaxis: { min: -10, max: 40 },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          gradientToColors: ["#FDD835"],
          shadeIntensity: 1,
          type: "horizontal",
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100],
        },
      },
      grid: {
        padding: { left: 10, right: 20, top: 0, bottom: -5 },
      },
    }),
    required: true,
  },
  heightLoading: {
    type: Number || String,
    default: 0,
  },
  classChart: {
    type: String,
    default: "",
  },
  isChangeSize: {
    type: Boolean,
    default: false,
  },
});

const chartRef: any = ref(null);
</script>

<style lang="scss" scoped>
.container {
  padding-left: 0px;
  padding-right: 0px;

  &::-webkit-scrollbar {
    width: 0px;
  }
}
</style>
